import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Subject, Observable } from "rxjs";
import {
  RequireMatch,
  ConfigurationService,
  Configuration,
} from "../../../core";
import { startWith, map } from "rxjs/operators";

@Component({
  standalone: false,
  selector: "app-dispatch-type-autocomplete",
  templateUrl: "./dispatch-type-autocomplete.component.html",
  styleUrls: ["./dispatch-type-autocomplete.component.sass"],
})
export class DispatchTypeAutocompleteComponent implements OnInit {
  @Input() placeholder: string = "Tipo de despacho";
  @Input() isRequired: boolean = false;
  @Input() defaultDispatchType: string;
  @Input() dispatchTypesToHide: string[] = [];
  @Output() onSelectDispatchType = new EventEmitter<any>();
  @Output() onResetDispatchType = new EventEmitter<boolean>();
  formIsEnabled: boolean = true;
  dispatchTypeList: Configuration[] = [];
  dispatchTypeAutocompleteList: Observable<any[]>;
  private onDestroy$: Subject<void> = new Subject<void>();
  dispatchType: FormControl = new FormControl();

  constructor(private configurationService: ConfigurationService) {
    this.dispatchType.setValidators(RequireMatch);
  }

  ngOnInit() {
    this.setRequiredInput();
    this.getTypeOfDispatches(this.defaultDispatchType);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  setRequiredInput() {
    if (this.isRequired) {
      this.dispatchType.setValidators([Validators.required, RequireMatch]);
      this.dispatchType.updateValueAndValidity();
    }
  }

  getTypeOfDispatches(dispatchTypeCode?: string) {
    this.dispatchTypeList = [];
    this.configurationService
      .read("DISPATCH_TYPE")
      .subscribe((response: Configuration[]) => {
        if (response) {
          this.dispatchTypeList = this.filterDispatchTypeByList(response);
          this.showDispatchType();
          if (dispatchTypeCode) {
            this.setDispatchType(dispatchTypeCode);
          }
        }
      });
  }

  filterDispatchTypeByList(dispatchTypeList: Configuration[]) {
    let dispatchTypeListFiltered: Configuration[] = [];
    if (this.dispatchTypesToHide.length == 0) {
      dispatchTypeListFiltered = dispatchTypeList;
    } else {
      dispatchTypeList.map((dispatchType) => {
        const dispatchTypeFound = this.dispatchTypesToHide.find(
          (item) => item == dispatchType.configValue
        );
        if (!dispatchTypeFound) {
          dispatchTypeListFiltered.push(dispatchType);
        }
      });
    }
    return dispatchTypeListFiltered;
  }

  displayFnDispatchType(dispatchType): string {
    return dispatchType
      ? dispatchType.configName
        ? dispatchType.configName
        : dispatchType
      : null;
  }

  showDispatchType() {
    this.dispatchTypeAutocompleteList = this.dispatchType.valueChanges.pipe(
      startWith(""),
      map((value) =>
        !value || typeof value === "string" ? value : value.configName
      ),
      map((value) =>
        value ? this.filterDispatchType(value) : this.dispatchTypeList.slice()
      )
    );
  }

  filterDispatchType(value) {
    const filterValue = value.toLowerCase();
    return this.dispatchTypeList.filter(
      (item) =>
        item.configName.toString().toLowerCase().indexOf(filterValue) >= 0
    );
  }

  cleanDispatchType() {
    this.dispatchType.setValue(null);
    this.showDispatchType();
    this.onResetDispatchType.emit(true);
  }

  changeSelectDispatchTYpe() {
    this.onSelectDispatchType.emit(this.dispatchType.value.configValue);
  }

  setDispatchType(dispatchTypeCode: string) {
    if (this.dispatchTypeList.length == 0) {
      return;
    }
    const dispatchTypeSelected: Configuration = this.dispatchTypeList.find(
      (dispatchType: Configuration) =>
        dispatchType.configValue === dispatchTypeCode
    );
    this.setDispatchTypeValue(dispatchTypeSelected);
  }

  setDispatchTypeValue(dispatchTypeSelected: Configuration) {
    if (dispatchTypeSelected) {
      if (
        dispatchTypeSelected.configValue != this.defaultDispatchType ||
        !this.dispatchType.value
      ) {
        this.dispatchType.setValue(dispatchTypeSelected);
        this.changeSelectDispatchTYpe();
      }
    }
  }
  disableForm() {
    this.dispatchType.disable();
    this.formIsEnabled = false;
  }

  enableForm() {
    this.dispatchType.enable();
    this.formIsEnabled = true;
  }
}
